export class Token {
    public access_token: string;
    public expires_in: string;
    public token_type: string;
    constructor (access_token: string = null) {
        this.access_token = access_token;
        this.expires_in = '3600';
        this.token_type = 'Bearer';
    }
}

export class AcrValues {
    public merchantId: string;
    public loanApplicationId: string;
    public merchantCustomerId: string;
    constructor(loanApplicationId: string, merchantId: string, merchantCustomerId: string) {
        this.loanApplicationId = loanApplicationId;
        this.merchantId = merchantId;
        this.merchantCustomerId = merchantCustomerId;
    }
}

export class CliLinkData {
    public link: boolean;
    public flow: string;
    constructor(link: boolean = false, flow: string = '') {
        this.link = link;
        this.flow = flow;
    }
}

export enum JourneyFlowType {
    Default = 0,
    Idff = 1,
    IdffBolt = 2,
    Bolt = 3,
    Unified = 4,
}

export const getJourneyTypeFromJourneyVersion = (version: string) => {
    let jourenyType: JourneyFlowType;
    jourenyType = JourneyFlowType.Unified;
    // switch (version) {
    //   case '8.0':
    //   case '9.1':
    //   case '9.2':
    //     jourenyType = JourneyFlowType.Unified;
    //     break;
    //   case '6.0':
    //     jourenyType = JourneyFlowType.Idff;
    //     break;
    //   case '7.0':
    //     jourenyType = JourneyFlowType.Bolt;
    //     break;
    //   case '7.1':
    //     jourenyType = JourneyFlowType.IdffBolt;
    //     break;
    //   default:
    //     jourenyType = JourneyFlowType.Default;
    //     break;
    // }
    return jourenyType;
  };
